export enum OrderSummaryTestIds {
  QUANTITY = 'order-summary-quantity',
  PIECES = 'order-summary-pieces',
  DELIVERIES = 'order-summary-deliveries',
  GROSS_ITEMS = 'order-summary-gross-items',
  PRICE_COMPOSITION = 'order-summary-price-composition',
  SUBTOTAL = 'order-summary-subtotal',
  INCOME_STATUS = 'order-summary-income-status',
  REVIEW_BUTTON = 'order-summary-review-button',
  MORE_ACTIONS_BUTTON = 'order-summary-more-actions-button',
  CONTINUE_TO_CONDITIONS_BUTTON = 'order-summary-continue-to-conditions-button',
  CONTINUE_BUTTON = 'order-summary-continue-button',
}
